import fetch from '../api/fetch'

/**
 *   Recover Password Actions
 */
export function fetchRecoverPassword(values: object) {
    return {
        type    : 'FETCH_RECOVERPASSWORD',
        payload : fetch('/user/reset_password', { method: 'PATCH', body: values }),
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/user.recoverpassword.ts